import { useMemo } from 'react';
import { getFailContent } from 'hooks/business/im/useMsgToConversation';
import { AIServiceLimitReached } from '../AIServiceLimitReached';
import ScenarioPreview from '../MessageScenario/ScenarioPreview';
import { useSearchMsgSelectedSendTime } from 'hooks/business/searchMsgSelectedMsg';
import ExtraTag from '../LargeBook/ExtraTag';
import { supportReadPlatforms } from '../../constants';
import { useTranslate } from '@tolgee/react';
import { useChatContext } from '../../contexts/ChatContext';
import { MsgRelateTodo } from '../../../Sider/ToDoBundle/MsgRelateTodo';
import { ProductKnowledgeQA } from './ProductKnowledgeQA';
import { MessageExtendFooterProps } from './types';
import { AssistantFooter } from './AssistantFooter';

export const MessageExtendFooter = (props: MessageExtendFooterProps) => {
  const { raw, msg, conversation, layout } = props;
  const { msgId, msgFromType, readFlag = false } = raw;
  const { type, status } = msg;
  const { channel } = conversation;
  const { t } = useTranslate();
  const { iframeMode, targetMessageExtra, galaxyModule, isGalaxy } = useChatContext();

  const searchSelectedMsg = useSearchMsgSelectedSendTime();

  const read = useMemo(() => {
    const isRenderReadInfo =
      status === 'normal' &&
      supportReadPlatforms.includes(channel) &&
      (msgFromType === 'ASSISTANT' || msgFromType === 'BOT');

    return isRenderReadInfo ? (
      <div className="flex justify-between items-center">
        <span />
        <span className="text-[var(--fett-text-quaternary)]">
          {t(readFlag ? 'ViewsChat.已读' : 'ViewsChat.未读')}
        </span>
      </div>
    ) : null;
  }, [channel, msgFromType, readFlag, status, t]);

  const mainContent = useMemo(() => {
    // AI服务套餐内次数耗尽
    const failContent = getFailContent(raw);

    if (
      failContent?.code === 'BOT_SENT_LIMIT_REACHED' ||
      failContent?.code === 'LIGHTWEIGHT_BOT_SENT_LIMIT_REACHED'
    ) {
      return (
        <AIServiceLimitReached
          message={raw}
          type={failContent?.code === 'BOT_SENT_LIMIT_REACHED' ? 'bot' : 'lightWeight'}
        />
      );
    }
    if (msgFromType === 'BOT') {
      return <ScenarioPreview message={raw} conversation={conversation} isGalaxy={isGalaxy} />;
    }

    // 议价结果不好判断是产生自官方或乐聊
    if (msgFromType === 'ASSISTANT' && type !== 'offer') {
      return <AssistantFooter raw={raw} conversation={conversation} isGalaxy={isGalaxy} />;
    }

    return null;
  }, [raw, msgFromType, isGalaxy, conversation, type]);

  const extraRender = useMemo(() => {
    if (iframeMode) {
      if (galaxyModule === 'productKnowledge') {
        return <ProductKnowledgeQA msgId={raw.msgId} />;
      }
      return <ExtraTag message={raw} float={layout} />;
    }
    return null;
  }, [iframeMode, raw, layout, galaxyModule]);

  return (
    <>
      {mainContent}
      {searchSelectedMsg.msgId === msgId && targetMessageExtra}
      {extraRender}
      {read}
      <MsgRelateTodo msgId={msgId} />
    </>
  );
};
